import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ContainerListFilter } from 'app/navis/models/ContainerListFilter';

@Injectable({
    providedIn: 'root'
})
export class NavisService {
    constructor(private http: HttpClient) {}

    getNavisContainer(unitNumber: string) {
        return this.http.get<any>(
            'api:///NavisExternal/getNavisContainer?unitNumber=' +
                unitNumber +
                '&operatorId=BMF&complexId=BURGAS&facilityId=ACT'
        );
    }

    getNavisVesselVisit(visitId: string) {
        return this.http.get<any>(
            'api:///NavisExternal/getNavisVesselVisit?visitId=' +
                visitId +
                '&operatorId=BMF&complexId=BURGAS&facilityId=ACT'
        );
    }

    getNavisVesselVisitsByCallSign(callSign: string) {
        return this.http.get<any>(`api:///NavisExternal/getNavisVesselVisitsByCallSign/${callSign}`);
    }

    getNavisInboundContainers(filter: ContainerListFilter) {
        return this.http.post<any>('api:///NavisExternal/getNavisInboundContainers', filter);
    }

    getNavisOutboundContainers(filter: ContainerListFilter) {
        return this.http.post<any>('api:///NavisExternal/getNavisOutboundContainers', filter);
    }

    getNavisAllContainers(filter: ContainerListFilter) {
        return this.http.post<any>('api:///NavisExternal/getNavisContainers', filter);
    }

    getNavisContainersForVisit(type: string, filter: ContainerListFilter) {
        if (type === 'Arrival') {
            return this.getNavisInboundContainers(filter);
        } else if (type === 'Departure') {
            return this.getNavisOutboundContainers(filter);
        } else {
            return this.getNavisAllContainers(filter);
        }
    }
}
